<script setup lang="ts">
const { t } = useI18n()

const props = defineProps<{
  isOpen: boolean
  handleClose: (isOpen: boolean) => void
  title?: string
  description?: string
}>()

const emit = defineEmits<{ (e: 'onConfirm'): void }>()

const confirmationTitle = computed(
  () => props.title ?? t('pages.marketingFlow.marketingFlowEditPage.deleteConfirmation')
)
const confirmationDescription = computed(
  () => props.description ?? t('pages.marketingFlow.marketingFlowEditPage.deleteDisclaimer')
)
</script>

<template>
  <BaseModal :is-open="isOpen" size="lg" :show-footer="false" @close="handleClose(false)">
    <div class="flex w-full flex-row justify-center">
      <div class="flex h-10 w-10 items-center justify-center rounded-full bg-red-100">
        <BaseIcon name="HeroTrashIconSolid" class="h-6 w-6 text-red-600" />
      </div>
    </div>

    <p class="mt-5 text-center font-semibold">
      {{ confirmationTitle }}
    </p>

    <p class="mb-5 mt-2 text-center text-sm text-foreground-secondary">
      {{ confirmationDescription }}
    </p>

    <div class="flex w-full flex-row justify-center">
      <Button variant="outline" class="mr-3 flex-1" @click="handleClose(false)">
        <span class="text-foreground">{{ t('global.words.back') }}</span>
      </Button>

      <Button variant="default-primary" class="flex-1" @click="emit('onConfirm')">
        {{ t('pages.marketingFlow.marketingFlowEditPage.deleteButton') }}
      </Button>
    </div>
  </BaseModal>
</template>
